package top.wcpe.allincore.dsl.compiler.ast

/**
 * RFC-RECOMPOSITION：元素树遍历辅助。
 *
 * <p>统一封装"访问元素的全部直接子树"语义：现有 [ElementAst.children] 之外，还需要把
 * [ElementAst.conditionalContent] 的各 branch.body 与 elseBranch 一并暴露。
 *
 * <p>语义层 / 类型推断 / 引用解析等 checker 之前只递归 children，导致 conditional 包装
 * 节点（kind=$cond，children=emptyList）的分支体被完全跳过——分支内的引用错 / 类型错 /
 * 形参冲突等都逃过编译期校验。本工具集中处理这一遍历点，避免每个 checker 自行做法不一致。</p>
 *
 * <p>不包含 menuBlocks：现有各 checker 对 menuBlocks 的处理本就不一致（仅 ElementValidator
 * 显式递归），保持现状，避免本次改造扩散。</p>
 */
internal object ElementWalk {

    /**
     * 返回 [element] 应被递归 walk 的全部直接子元素，按"DSL 中出现顺序"排列：
     *  1. [ElementAst.children]
     *  2. 若有 [ElementAst.conditionalContent]：先各 branch.body，再 elseBranch（如果存在）
     *
     * 调用方对返回结果再做完整的 walkElement 递归，即可覆盖整棵 conditional 子树。
     */
    fun directDescendants(element: ElementAst): Sequence<ElementAst> = sequence {
        yieldAll(element.children)
        val cond = element.conditionalContent
        if (cond != null) {
            for (branch in cond.branches) yield(branch.body)
            cond.elseBranch?.let { yield(it) }
        }
        // $for：循环体单根 element 同样要被各 checker 递归 walk。
        element.forContent?.let { yield(it.body) }
    }
}
